var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMe)?_c('Avatar',_vm._b({staticClass:"avatar",style:(_vm.cssVars),attrs:{"is-no-user":_vm.isNoUser,"show-user-status":_vm.showUserStatus}},'Avatar',_vm.$attrs,false)):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }